module.exports = __webpack_public_path__ + "static/super-admin-tag-form-18870ca76e95234d445bfd32e69bfd05.png";